<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <div class="main-content">
          <div class="main-content-center">
            <v-img
              :src="logoUrl"
              width="350"
              style="margin: 0 auto;"
            />
            <h4>Serveur inaccessible, merci de réessayer dans quelques instants.</h4>
            <p>{{ errorMsg }}</p>
            <p>
              <v-btn
                color="primary"
                flat
                @click="reload()"
              >
                Réessayer
              </v-btn>
            </p>
          </div>
        </div>
      </v-container>
    </v-content>
    <v-footer app>
      <v-spacer />
      <span>
        &copy;{{ year }},
        <a
          href="https://www.elac.ch"
          target="_blank"
        >
          Elac
        </a>
        ,&nbsp;
        <a
          href="https://www.voilab.ch"
          target="_blank"
        >
          Voilab
        </a>
      </span>
    </v-footer>
  </v-app>
</template>

<script>
import moment from 'moment';

export default {
  name: 'ElacError',

  data: () => ({
    year: moment().format('YYYY'),
    logoUrl: `${process.env.BASE_URL}elac-logo.svg`,
  }),

  computed: {
    errorMsg() {
      return this.currentError.message;
    },
  },

  mounted() {
    console.warn(this.currentError);
  },

  methods: {
    reload() {
      window.location.reload();
    },
  },
};
</script>

<style lang="stylus">
.main-content
    height 100%
    display flex

.main-content-center
    width 100%
    text-align center

.main-content-center v-responsive
    margin 10em auto 2em auto !important
    max-width 350px
    display block
    padding 1px

.footer
    justify-content flex-end

</style>
